
export const Complete = () => {
    return <div>
        <p>正しく送信されました。<br/>COTAERU担当者からの連絡をお待ちくださいませ。</p>
    </div>
}
